import { useMemo } from 'react';

import { ProgressMeasurement } from 'components/common/GlobalFilterComponent/components/progressMeasurementFilter/progressMeasurementFilter';

const FILTER_LIST: ProgressMeasurement[] = [
    'activityCompleted',
    'activityCompletedCriticality',
    'activitySubmittedCompletion',
    'activitySubmittedCompletionCriticality',
];

export const useProgressSummaryLogic = ({ ui, api }) => {
    const milestoneFragnetTaskVersionHashCode = useMemo(() => {
        if (ui.state.milestoneFragnet) {
            return ui.state.milestoneFragnet;
        }

        if (api.getMilestoneFragnet?.data && api.getMilestoneFragnet.data.length > 0) {
            return api.getMilestoneFragnet.data[0].task_version_hash_code;
        }
    }, [api.getMilestoneFragnet?.data, ui.state.milestoneFragnet]);

    const notApplicable =
        FILTER_LIST.includes(ui.state.progressMeasurement) && Boolean(ui.state.resourceType || ui.state.resource);

    const noResults =
        !Boolean(api.getBaselineVsActual.instance.data?.actual.finishDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.actual.startDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.baseLine.finishDate) &&
        !Boolean(api.getBaselineVsActual.instance.data?.baseLine.startDate);

    const isNoData = noResults || notApplicable;

    return { logic: { milestoneFragnetTaskVersionHashCode, isNoData, notApplicable } };
};
